import { User } from "../types/types";

const key = "USER";

const userStorage = {
  get() {
    const data = localStorage.getItem(key);
    try {
      if (!data) return null;
      const parsed = JSON.parse(data) as User;
      return parsed;
    } catch (e) {
      localStorage.removeItem(key);
      return null;
    }
  },
  set(user: User) {
    localStorage.setItem(key, JSON.stringify(user));
    localStorage.setItem(
      "image",
      user.admin_image ? user.admin_image : ""
    );
  },
  setName(image: string) {
    localStorage.setItem("image", image);
  },
  getName() {
    return localStorage.getItem("image");
  },
  clear() {
    localStorage.removeItem(key);
  },
};

export default userStorage;
